"use strict";

module.exports = {
    handle2FA: function () {
        $("#form-2fa").on("submit", function (e) {
            e.preventDefault();
            var $form = $(this);
            var url = $form.attr("action");
            var formData = $form.serialize();

            $.ajax({
                url: url,
                type: "post",
                data: formData,
                success: function (data) {
                    if (data.success) {
                        location.href = data.redirectUrl;
                    } else {
                        var $input = $form.find("#2fa-code");
                        $input.addClass("is-invalid");
                        $form.find(".invalid-feedback").text(data.error[0]);
                    }
                },
                error: function (err) {
                    console.error("2FA Error:", err);
                }
            });
        });

        $("#resend-2fa").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr("href");

            $.ajax({
                url: url,
                type: "get",
                success: function (data) {
                    if (data.success) {
                        alert(data.message);
                    } else if (data.redirectUrl) {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    console.error("Resend Error:", err);
                }
            });
        });
    }
};
